
<template>
  <client-only>
    <v-container pa-0>
      <v-row>
        <v-col
          cols="12"
          class="pa-0 pb-2"
          :class="fontSize + (darkMode ? ' dark' : ' pumpkin')"
        >
          <div v-if="!breakLine" class="pr-3">
            <span>{{ displayDate }}</span>
            <span class="d-inline-block mx-2">|</span>
            <span>{{ item.author }}</span>
            <span class="d-inline-block mx-2">|</span>
            <br v-if="$vuetify.breakpoint.xsOnly" />
            <span>{{ readingTime }}</span>
            <span class="d-inline-block mx-2">|</span>
            <ShareJob
              :url="`https://drushim.co.il${articleLink}`"
              :title="title"
              :description="previewText"
              :quote="title"
              :class="darkMode ? 'd-inline dark' : 'd-inline'"
            />
          </div>

          <div v-else class="bottom-footer pr-3">
            <span class="d-block">{{ displayDate }}</span>
            <div class="d-inline-block">
              <span>{{ readingTime }}</span>
              <span class="mx-1">|</span>
              <ShareJob
                :url="`https://drushim.co.il${articleLink}`"
                :title="title"
                :description="previewText"
                :quote="title"
                :class="darkMode ? 'd-inline mr-1 dark' : 'd-inline mr-1 '"
              />
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </client-only>
</template>
 
<script>
import { isNil } from 'lodash';
import ArticleLinkVue from './mixins/ArticleLink.js';
import ArticleTitleVue from './mixins/ArticleTitle.js';
import { t } from '@/store/modules/homeDrushim/constantsContent';

import ShareJob from '@/components/Jobs_List/Share_Job/ShareJob';
export default {
  mixins: [ArticleLinkVue, ArticleTitleVue],
  components: {
    ShareJob,
  },
  props: {
    item: {
      type: Object,
      required: false,
    },
    breakLine: {
      type: Boolean,
      required: false,
      default: false,
    },
    darkMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    fontSize: {
      type: String,
      required: false,
      default: 'display-15-15',
    },
  },
  computed: {
    readingTime() {
      return !isNil(this.item) && !isNil(this.item.readingTime)
        ? t('titles.articles.readingTimeString', { readingTime: this.item.readingTime })
        : '';
    },
    displayDate() {
      return !isNil(this.item) && !isNil(this.item.date)
        ? this.item.date
        : '';
    },
    previewText() {
      return !isNil(this.item) && !isNil(this.item.text)
        ? this.item.text
        : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.pumpkin {
  color: #ff7100;
}

.dark {
  color: #ffffff;
}

.bottom-footer {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 40px;
}
@media screen and (min-width: 600px) {
}
</style>
